import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';

import Logo from '@/components/Logo';

const useStyles = makeStyles(theme => ({
  meter:{
    borderRadius:25,
    display: 'inline-block',
    height: 10,
    width: '100%',
    '& span':{
      display: 'block',
      height: '100%',
      borderRadius: 5
    }
  }
}));

function getTeamStat(side, stat){
  if(side === 'visitor'){
    return [stat.visitor.stat, stat.home.stat];
  }

  return [stat.home.stat, stat.visitor.stat]
}

function getTeamId(side, stat){
  return stat[side].team.id;
}

function generateMeter(teamStat, opponentStat){
    let width = '100%';

    if(opponentStat > teamStat){
        width = `${teamStat / opponentStat * 100}%`;
    }

    if(!Boolean(teamStat)){
      width = '0%';
    }

    return <span style={{ background:'red', width: width }} />
}

const TeamStat = ({ side, stat }) => {
  const classes = useStyles();
  const [teamStat, opponentStat] = getTeamStat(side, stat);
  return (
    <Grid container alignItems="center" spacing={2}>
      <Grid item xs={2}>
        <Logo id={getTeamId(side, stat)} />
      </Grid>
      <Grid item xs={8}>
        <div className={classes.meter}>
          { generateMeter(teamStat, opponentStat) }
        </div>
      </Grid>
      <Grid item xs={2}>
        <Typography align="right" variant="h6" component="p">{teamStat}</Typography>
      </Grid>
    </Grid>
  );
}


export default TeamStat;